module.exports = __webpack_public_path__ + "static/media/aboutImage.d6ca7bdc.jpg";